"use client";
import { motion } from "framer-motion";
import { FaQuoteLeft, FaStar } from "react-icons/fa";

const testimonials = [
  {
    id: 1,
    quote:
      "Our website redesign with Perftecht's development team transformed our online presence. The new site loads lightning-fast, looks modern, and ranks higher on Google thanks to their SEO best practices.",
    author: "Parveen K",
    role: "AAP Commercial Cleaners",
    rating: 5,
    highlight: "Modern, fast, and SEO-optimized site",
  },
  {
    id: 2,
    quote:
      "Their digital marketing campaigns significantly boosted our website traffic and brand awareness. We saw a 150% increase in qualified leads within the first two months.",
    author: "Muhammad Shoaib",
    role: "Managing Director, ASF",
    rating: 5,
    highlight: "150% more qualified leads",
  },
  {
    id: 3,
    quote:
      "We partnered with them to launch our new e-commerce website, and the results have been phenomenal. Our online sales doubled within weeks, and their ongoing SEO support keeps us ahead of the competition.",
    author: "Kelly Malick",
    role: "Founder, NutriHut",
    rating: 5,
    highlight: "Sales doubled after website launch",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials__container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="testimonials__header"
        >
          <h2 className="testimonials__title">
            Client <span className="testimonials__title-accent">Success</span>
          </h2>
          <p className="testimonials__subtitle">
            Trusted by industry leaders to deliver exceptional results
          </p>
        </motion.div>

        <div className="testimonials__grid">
          {testimonials.map((testimonial, index) => (
            <motion.article
              key={testimonial.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="testimonials__card"
            >
              <div className="testimonials__card-inner">
                <div className="testimonials__quote-header">
                  <FaQuoteLeft className="testimonials__quote-icon" />
                  <div className="testimonials__highlight">
                    {testimonial.highlight}
                  </div>
                </div>

                <p className="testimonials__quote">{testimonial.quote}</p>

                <div className="testimonials__rating">
                  {[...Array(5)].map((_, i) => (
                    <motion.div
                      key={i}
                      whileHover={{ scale: 1.2 }}
                      className="testimonials__star-container"
                    >
                      <FaStar
                        className={`testimonials__star ${
                          i < testimonial.rating
                            ? "testimonials__star--filled"
                            : ""
                        }`}
                      />
                    </motion.div>
                  ))}
                </div>

                <div className="testimonials__author">
                  <h4 className="testimonials__author-name">
                    {testimonial.author}
                  </h4>
                  <p className="testimonials__author-role">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
